import React, { useCallback } from 'react';

import Accordion from '../../offers-cards/components/Accordion/Accordion';
import { FormattedGroup } from '../types';

export const Groups = ({
  groups,
  moreChannelsIcon
}: {
  groups: FormattedGroup[];
  moreChannelsIcon: { label: string | null; href: string };
}) => {
  const renderGroup = useCallback(
    (group, index) => (
      <Accordion
        index={index}
        channels={group.channels}
        descriptions={group.descriptions}
        hasDescriptionsIcon={group.hasDescriptionsIcon}
        displayChevron={group.displayChevron}
        isMoreChannels={group.isMoreChannels}
        key={group.title}
        moreChannelsIcon={moreChannelsIcon}
        title={group.title}
      />
    ),
    [moreChannelsIcon]
  );

  return <>{groups.map(renderGroup)}</>;
};
